export default function setTitleAction(title) {
    return {
        type: 'SET_TITLE',
        payload: title
    }
}